function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-31.789 -98)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-204.638 -83.619)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M247.142,182.432q2.361,0,4.721,0c.75,0,1.171.374,1.166,1.025s-.427,1.005-1.187,1.006q-4.72,0-9.442,0c-.751,0-1.171-.374-1.166-1.026s.424-1,1.187-1Q244.782,182.43,247.142,182.432Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M247.106,189.27q-2.359,0-4.721,0c-.741,0-1.163-.387-1.151-1.04.011-.625.429-.989,1.151-.99q4.746,0,9.493,0c.741,0,1.163.387,1.151,1.04-.011.623-.432.989-1.151.99Q249.492,189.274,247.106,189.27Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M247.132,194.044q-2.387,0-4.772,0a1.02,1.02,0,1,1,0-2.03q4.771,0,9.544,0a1.02,1.02,0,1,1,0,2.029C250.313,194.046,248.722,194.044,247.132,194.044Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M236.427,192.995a1.626,1.626,0,1,1,1.607,1.659A1.6,1.6,0,0,1,236.427,192.995Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M236.428,183.225a1.626,1.626,0,1,1,1.618,1.646A1.6,1.6,0,0,1,236.428,183.225Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M238.073,186.628a1.626,1.626,0,1,1-1.645,1.618A1.6,1.6,0,0,1,238.073,186.628Z"
})));

function SvgList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#1899ae",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.602,
    height: 13.035,
    viewBox: "0 0 16.602 13.035",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.f22caee4a73e8306d45bdab205ad1904.svg";
export { ForwardRef as ReactComponent };